import RlLogoVariant from "./@types/RlLogoVariant";

export const getLogoUri = (variant: RlLogoVariant) => {
  switch (variant) {
    case "long":
      return "/static/images/logo-spectra-analyze-long.svg";
    case "short":
      return "/static/images/logo-spectra-analyze-short.svg";
    default:
      return "/static/images/rl-logo-square.svg";
  }
};
